import clsx from 'clsx';
import { camelCase, isEmpty } from 'lodash';
import { object } from 'prop-types';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ApiImg, Icon, ProductsContext, SanitizedHtml } from 'components';
import { capitalizeFirstLetter, getSubTypeLogo } from 'helpers';

const LeisureItem = ({ leisure }) => {
  const { t } = useTranslation();
  const { leisureCategoryFilters, goToProductSow, pageType } = useContext(ProductsContext);

  const getLeisureCategory = useCallback(
    (categoryId) => {
      let categoryName = leisureCategoryFilters?.find((category) => category.id === categoryId)?.name;
      if (categoryName) categoryName = capitalizeFirstLetter(categoryName);
      return categoryName ?? '';
    },
    [leisureCategoryFilters]
  );

  return (
    <div className="product-item leisure w-full" onClick={() => goToProductSow(leisure, pageType)}>
      <div className="image-container">
        <div className="h-full w-full lg:h-[14.38rem] lg:rounded-tl-xl lg:rounded-tr-xl lg:overflow-hidden">
          <ApiImg src={leisure.vignette} width="116" height="200" className="object-left lg:object-top" />
        </div>
      </div>

      <div className="content-container">
        <div className="flex-center-between gap-2">
          {getLeisureCategory(leisure.category) && (
            <div className={clsx('badge', !isEmpty(leisure.subType) && 'truncate-line one-line')}>
              {getLeisureCategory(leisure.category)}
            </div>
          )}

          {getSubTypeLogo(leisure.subType) && (
            <div className="h-8">
              <img
                src={getSubTypeLogo(leisure.subType)}
                alt={t(`alts.${camelCase(leisure.subType)}`)}
                className="h-full object-contain"
                width="57"
                height="32"
              />
            </div>
          )}
        </div>

        <h3 className="h3 truncate-line one-line">{leisure.title}</h3>

        <div className="content-text py-1 text-gray-600">
          <SanitizedHtml content={leisure.resume} className="truncate-line four-lines" filterEmpty />

          {(leisure.city || leisure.country) && (
            <div className="mt-2 flex items-baseline gap-3 text-gray-600 text-xs capitalize">
              <Icon name="location-dot" iconStyle="fad" />
              {leisure.country}
              {leisure.country && leisure.city && ' - '}
              {leisure.city}
            </div>
          )}
        </div>
        <div className="flex items-center flex-wrap gap-1 mt-3">
          {t('fromPrice')} <span className="text-secondary-500 text-lg font-medium">{leisure.price} €</span>
        </div>
      </div>
    </div>
  );
};

LeisureItem.propTypes = {
  leisure: object.isRequired
};

export default LeisureItem;
